import React, { createContext, useContext } from 'react';

const BuildoutOsDisplayContext = createContext(false);

interface Props {
  children: React.ReactNode;
  enabled: boolean;
}

export function BuildoutOsDisplayProvider({ children, enabled }: Props) {
  return (
    <BuildoutOsDisplayContext.Provider value={enabled}>
      {children}
    </BuildoutOsDisplayContext.Provider>
  );
}

export function useBuildoutOsDisplay(): boolean {
  return useContext(BuildoutOsDisplayContext);
}
